/// <amd-module name="Wit/WorkItemForm/Common/Components/EditCommentDialog" />
import * as React from "react";
import { useState } from "react";
import { Dialog } from "VSSUI/Dialog";
import { TextField } from "VSSUI/TextField";
import * as Resources from "Wit/WorkItemForm/Resources";

export interface IEditCommentDialogProps {
    comment: string;
    onCommitComment: (newComment: string) => void;
    onDismiss: () => void;
}

export function EditCommentDialog({ comment, onCommitComment, onDismiss }: IEditCommentDialogProps) {
    const [newComment, setNewComment] = useState(comment);
    const textFieldRef = React.useRef<TextField>(null);

    React.useEffect(() => {
        //setTimeout ensures focus is called after TextField is fully rendered and attached to the DOM
        setTimeout(() => {
            textFieldRef.current?.focus();
        }, 0);
    }, []);

    return (
        <Dialog
            lightDismiss
            escDismiss
            titleProps={{ text: Resources.EditComment }}
            footerButtonProps={[
                {
                    text: Resources.ConfirmEditComment,
                    onClick: () => onCommitComment(newComment),
                    disabled: comment == newComment,
                    primary: true
                },
                {
                    text: Resources.CancelEditComment,
                    onClick: onDismiss
                }
            ]}
            onDismiss={onDismiss}
        >
            <TextField
                label={Resources.CommentFieldLabel}
                value={newComment}
                onChange={(_event, newValue) => setNewComment(newValue)}
                ref={textFieldRef}
            />
        </Dialog>
    );
}
